import ReactDOM from 'react-dom'
import CarsSearch from '../../CarsSearch/CarsSearch'

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<CarsSearch />, document.getElementById('root'))
})
